import dayjs from './libs/dayjs.min.js'
import relativeTime from './libs/plugin/relativeTime.min.js';
import logger from './logger';
import ChunkReplacer from './chunkreplacer';
import {HtmlTemplates} from "./html-templates";

dayjs.extend(relativeTime);


const handleClickEmailMetric = async (delivery_id) => {
	const body = {
		fn: "update_metrics",
		data: {
			delivery_id,
			metric: 'clicked',
			casino: sessionStorage.getItem('casino'),
			reason: 'app'
		},
		plugin: "message_center",
	}

	const data = await fetch(URL_PREFIX + 'apps/notification/get_notification.php', {
		method: 'POST', body: JSON.stringify(body), headers: {...new Headers(), 'Content-Type': 'application/json'},
	});
	const res = await data.json();
	return res ? res : null;
}

window.handleOnClick = async function(event, element) {
	event.preventDefault();
	const originalHref = element.getAttribute('data-original-href');
	const deliveryId = element.getAttribute('data-delivery-id');

	if (originalHref) {
		await handleClickEmailMetric(deliveryId);

		window.open(originalHref, '_blank');
	}
};

export let Notifications = (() => {
	let offset = 0;
	const limit = 20;
	let hasMoreNotifications = true;
	let isFetching = false;
	const pid = sessionStorage.getItem('pid');
	const username = sessionStorage.getItem('username');
	const casino = sessionStorage.getItem('casino');
	const is_depositor = Number(sessionStorage.getItem('is_depositor'));

	const UPLOADS_FOLDER = casino === "brango" || casino === 'extreme' ? '/images/uploads' : '/public/img/uploads'

	const notificationsApi = URL_PREFIX + 'apps/notification/get_notification.php';
	
	const processingNotificationBoxes = new Set();

	async function checkEmailVerification() {
		let res = await fetch(URL_API('isEmailVerified', 'user'));
		res = await res.json();

		return res;
	}

	const getNotificationBtn = () => {
		return document.querySelector('.notification--btn');
	}

	const getEmailBtn = () => {
		return document.querySelector('.email--btn');
	}

	const getIsMobile = () => {
		return Boolean(document.querySelector('#MobileBar'))
	}
	//
	const getTriggers = () => {
		return document.querySelectorAll('[data-toggle="notifications"]')
	};

	//
	const getModal = () => {
		return document.getElementById('notificationsFull')
	};

	const getNotificationList = () => {
		return $('.notifications--list');
	}

	const getEmailNotificationList = () => {
		return $('.email--notifications--list');
	}

	const toggleLoader = () => {
		document.getElementById('notificationsLoader').classList.toggle('showing');
	}

	const clearNotificationList = () => {
		getNotificationList().empty();
		getEmailNotificationList().empty();
	};

	const normalizeAttribute = value => (value === 'null' || value === 'undefined' ? null : Number(value));


	const outputNotificationTemplate = ({
												  isSeen,
												  title,
												  description,
												  time,
												  mobileImg,
												  desktopImg,
												  redirectUrl,
												  notificationId,
												  notificationDetailId,
													notif
											  }) => {
		const isMobile = getIsMobile();
		const imageName = isMobile ? mobileImg : desktopImg;

		return (new ChunkReplacer)
			.add('SEEN', isSeen ? 'seen' : '')
			.add('NOTIFICATION_ID', notificationId)
			.add('NOTIFICATION_DETAIL_ID', notificationDetailId)
			.add('REDIRECT_URL', redirectUrl)
			.add('IMAGE', imageName ? `
          <div class="image--wrapper">
            <img src="${UPLOADS_FOLDER}/notifications/${imageName}" alt="notification-image" />
          </div>` : '')
			.add('TITLE', title)
			.add('DESCRIPTION', description)
			.add('TIME', time)
			.replace(notif);
	};

	const toggleModal = () => {
		clearNotificationList();
		getEmailNotificationList().addClass('hide');
		getNotificationList().removeClass('hide')
		const modal = getModal();
		toggleObstacles();
		modal.classList.toggle('open');
		document.body.style.overflow = document.body.style.overflow === 'hidden' ? 'scroll' : 'hidden';

		if (modal.classList.contains('open')) {
			const notificationBtn = getNotificationBtn();
			const emailBtn = getEmailBtn();
			notificationBtn.classList.add('active');
			emailBtn.classList.remove('active');
			const countElement = document.querySelector('[data-toggle="notifications"] .count');
			const totNotificationCount = countElement ? parseInt(countElement.textContent.trim(), 10) : 0;

			let notificationsEmailCount = Number(localStorage.getItem('emailNotificationCount')) ?? 0;

			if (notificationsEmailCount) {
				emailBtn.classList.remove('seen');
			} else {
				emailBtn.classList.add('seen');
			}

			if(totNotificationCount > notificationsEmailCount) {
				notificationBtn.classList.add('active');
				emailBtn.classList.remove('active');
				getNotificationList().removeClass('hide');
				getEmailNotificationList().addClass('hide');
				loadNotifications()
			}else {
				notificationBtn.classList.remove('active');
				emailBtn.classList.add('active');
				getNotificationList().addClass('hide');
				getNotificationList().addClass('hide');
				getEmailNotificationList().removeClass('hide');
				loadEmailNotifications()
			}


			offset = 0;
			hasMoreNotifications = true;
			loadNotifications().then(r => {
				setupInfiniteScroll();
				setupBtnListeners();
			});
		} else {
			clearNotificationList();
		}
	};

	//
	const toggleObstacles = () => {
		const mobileBar = document.getElementById('MobileBar');
		const hambMenu = document.getElementById('BtnHamMenu');

		if (mobileBar && hambMenu) {
			mobileBar.classList.toggle('hide');
			hambMenu.classList.toggle('hide');
		}
	}

	const loadNotifications = async () => {
		if (isFetching || !hasMoreNotifications) return;
		isFetching = true;

		toggleLoader();

		try {
			const notificationsData = await getNotifications(limit, offset);

			if (!notificationsData || notificationsData?.length < limit) {
				hasMoreNotifications = false;
			}

			await outputNotifications(notificationsData);
			setupNotificationListeners();
			offset += limit;
		} catch (error) {
			logger.error('Failed to load notifications:', error);
		} finally {
			toggleLoader();
			isFetching = false;
		}
	};

	const loadEmailNotifications = async () => {
		clearNotificationList()

		if (isFetching || !getModal().classList.contains('open')) return;
		isFetching = true;

		toggleLoader();

		try {
			const isEmailVerified = await checkEmailVerification()
			if (!getModal().classList.contains('open')) return
			if (!isEmailVerified) {
				const notificationListEl = getEmailNotificationList();

				return notificationListEl.html(`<div class="empty-wrapper">
        <img src='${UPLOADS_FOLDER}/verify-badge.png' alt='verify-badge'>
        <p class='empty--text'>You need to <span>verify</span> your email in order to view email notifications.</p>
        </div>`)
			}

			const emailNotificationsData = await getEmailNotifications();
			logger.log('DATA', emailNotificationsData)


			await outputEmailNotifications(emailNotificationsData.data);
			setupEmailNotificationListeners();
		} catch (error) {
			logger.error('Failed to load notifications:', error);
		} finally {
			toggleLoader();
			isFetching = false;
		}
	};

	const getEmailNotifications = async (limit = 7, offset = 0) => {
		const body = {
			fn: "get_emails",
			data: {
				casino: casino
			},
			plugin: "message_center",
			limit,
			offset
		}

		const data = await fetch(notificationsApi, {
			method: 'POST', body: JSON.stringify(body), headers: {...new Headers(), 'Content-Type': 'application/json'},
		});
		const res = await data.json();

		const currentTime = Date.now();
		localStorage.setItem('emailNotificationCount', res.unread_messages);
		localStorage.setItem('lastNotificationAPICallTimestamp', currentTime);
		return res ? res : null;
	}

	const getEmailTemplate = async (campaign_id, message_id, delivery_id, newsletter_id) => {
		const body = {
			fn: "get_email_template",
			data: {
				campaign_id,
				message_id,
				delivery_id,
				newsletter_id,
				casino:casino,
			},
			plugin: "message_center",
		}

		const data = await fetch(notificationsApi, {
			method: 'POST', body: JSON.stringify(body), headers: {...new Headers(), 'Content-Type': 'application/json'},
		});
		const res = await data.json();
		return res ? res.data : null;
	}

	const outputEmailNotificationTemplate = (isSeen, title, subtitle, time, campaign_id, messageID, delivery_id, newsletter_id, emailNotif) => {
		return (new ChunkReplacer)
			.add('SEEN', isSeen ? 'seen' : '')
			.add('SUBTITLE', subtitle)
			.add('TIME', time)
			.add('CAMPAIGN_ID', campaign_id)
			.add('DELIVERY_ID', delivery_id)
			.add('NEWSLETTER_ID', newsletter_id)
			.add('MESSAGE_ID', messageID)
			.add('TITLE', title)
			.replace(emailNotif);
	}

	const outputEmailNotifications = async (data) => {
		const notificationListEl = getEmailNotificationList();

		if (data?.length === 0 || !data) {
			return notificationListEl.html("<div class='empty-wrapper'><p class='empty--text'>You have no new emails.</p></div>")
		}
		let emailNotif = await HtmlTemplates.getTemplate(HtmlTemplates.emailNotification, true);

		data.forEach(({title, subTitle, messageID, campaign_id, metrics, delivery_id, is_newsletter}) => {
			const isSeen = metrics?.opened
			const time = dayjs(metrics.delivered * 1000).fromNow();
			const data = outputEmailNotificationTemplate(isSeen, title, subTitle, time, campaign_id, messageID, delivery_id, is_newsletter, emailNotif);
			notificationListEl.append(data)
		});

		notificationListEl.append("<p class='no-more-text'>That’s all for now!<br />You can view notifications from the last 7 days only.</p>")
	};


	const getNotifications = async (limit, offset) => {
		const body = {
			fn: "get_notifications",
			data: {
				login: username,
				casino: casino,
				is_depositor: is_depositor
			},
			plugin: "notifications",
			limit,
			offset
		}

		const data = await fetch(notificationsApi, {
			method: 'POST', body: JSON.stringify(body), headers: {...new Headers(), 'Content-Type': 'application/json'},
		});
		const res = await data.json();
		return res ? res : null;
	}

	const updateNotification = async (type, notificationId, notificationDetailId) => {
		const body = {
			fn: "update_notification",
			type,
			data: {
				login: username,
				casino: casino,
				notification_id: notificationId,
				notification_detail_id: notificationDetailId
			},
			plugin: "notifications"
		};

		const response = await fetch(notificationsApi, {
			method: 'POST',
			body: JSON.stringify(body),
			headers: {...new Headers(), 'Content-Type': 'application/json'}
		});

		const result = await response.json();

		return result ? result : null;
	}

	const outputNotifications = async (data) => {
		const notificationListEl = getNotificationList();
		if (data?.length === 0 || !data) {
			return notificationListEl.html("<div class='empty-wrapper'><p class='empty--text'>You have no new notifications.</p></div>")
		}

		let notif = await HtmlTemplates.getTemplate(HtmlTemplates.notification, true)

		data.forEach(({
						  count,
						  title,
						  body,
						  updated_at,
						  image_d,
						  image_m,
						  redirect_url,
						  notification_id,
						  notification_detail_id
					  }) => {
			const isSeen = Boolean(count);
			const time = dayjs(updated_at).fromNow();

			const data = outputNotificationTemplate({
				isSeen,
				title,
				description: body,
				time,
				mobileImg: image_m,
				desktopImg: image_d,
				redirectUrl: redirect_url,
				notificationId: notification_id,
				notificationDetailId: notification_detail_id,
				notif
			})

			notificationListEl.append(data);
		});
	};

	const setupInfiniteScroll = () => {
		const notificationListEl = getNotificationList();

		notificationListEl.on('scroll', async function () {
			if (
				notificationListEl.scrollTop + notificationListEl.clientHeight >=
				notificationListEl.scrollHeight
			) {
				await loadNotifications();
			}
		});
	};

	const handleNotificationClick = async (isSeen, redirectUrl, notificationId, notificationDetailId, notificationBox) => {
		// Create unique identifier for this box
		const boxId = notificationId + '-' + notificationDetailId;
		
		// Check if already processing - prevent spam clicks
		if (processingNotificationBoxes.has(boxId)) {
			return;
		}

		// Mark as processing
		processingNotificationBoxes.add(boxId);
		
		// Disable pointer events to prevent further clicks
		const originalPointerEvents = notificationBox.style.pointerEvents;
		notificationBox.style.pointerEvents = 'none';

		try {
			const result = await updateNotification('count', notificationId, notificationDetailId);

			if (result.error === 0) {
				notificationBox.classList.add('seen');
			} else {
				logger.error('Failed to mark notification as seen:', result.error);
			}
		} catch (error) {
			logger.error('Error marking notification as seen:', error);
		} finally {
			// Remove from processing set
			processingNotificationBoxes.delete(boxId);
			// Only restore pointer events if we're not redirecting
			if (!redirectUrl) {
				notificationBox.style.pointerEvents = originalPointerEvents || '';
			}
		}

		if (redirectUrl) {
			window.location.href = redirectUrl;
		}
	}

	const setupNotificationListeners = () => {
		const notificationList = getNotificationList()[0];

		if (!notificationList) return;

		if (notificationList._notificationClickHandler) {
			notificationList.removeEventListener('click', notificationList._notificationClickHandler);
		}

		notificationList._notificationClickHandler = async (event) => {
			const box = event.target.closest('.notification--box');
			if (!box) return;

			const notificationId = normalizeAttribute(box.getAttribute('data-notification-id'));
			const notificationDetailId = normalizeAttribute(box.getAttribute('data-notification-detail-id'));
			const redirectUrl = box.getAttribute('data-redirect-url');
			const isSeen = box.classList.contains('seen');

			if (event.target.matches('.close--icon')) {
				await handleDeleteNotification(notificationId, notificationDetailId, box);
				return;
			}

			await handleNotificationClick(isSeen, redirectUrl, notificationId, notificationDetailId, box);
		};

		notificationList.addEventListener('click', notificationList._notificationClickHandler);
	};

	const setupEmailNotificationListeners = () => {
		const notificationBoxes = document.querySelectorAll('.notification--box');

		notificationBoxes.forEach(box => {
			const titleBox = box.querySelector('.tophead-wrapper');
			titleBox.addEventListener('click', async () => {
				const emailBtn = getEmailBtn();
				const notificationsEmailCount = Number(localStorage.getItem('emailNotificationCount')) ?? 0;

			if (notificationsEmailCount) {
				emailBtn.classList.remove('seen');
			} else {
				emailBtn.classList.add('seen');
			}

				const messageId = normalizeAttribute(box.getAttribute('data-message-id'));
				const campaignId = normalizeAttribute(box.getAttribute('data-campaign-id'));
				const deliveryId = box.getAttribute('data-delivery-id');
				const newsletter_id = box.getAttribute('data-newsletter-id');
				await handleEmailNotificationClick(messageId, campaignId,deliveryId, newsletter_id, box);
			});
		});
	};

	const processEmailContent = (htmlString, deliveryId) => {
		// Create a temporary DOM element to parse the HTML
		const tempDiv = document.createElement('div');
		tempDiv.innerHTML = htmlString;

		// Find all anchor tags and add click handlers
		const anchorTags = tempDiv.querySelectorAll('a');
		anchorTags.forEach(anchor => {
			// Add a unique identifier to track clicks
			const originalHref = anchor.getAttribute('href');
			anchor.setAttribute('data-original-href', originalHref);
			anchor.setAttribute('data-delivery-id', deliveryId);

			// Add onclick handler
			anchor.setAttribute('onclick', 'handleOnClick(event, this)');
		});

		return tempDiv.innerHTML;
	};

	const errorHtmlTemplate = () => {
		return `<div class="error-msg">
    We have encountered an issue retrieving details for this email. <br />Please try again later.
</div>
    `
	}


	const handleEmailNotificationClick = async (messageId, campaignId,deliveryId, newsletter_id, box) => {
		const emailContentDiv = box.querySelector('.details--box--email')
		const notificationBoxes = document.querySelectorAll('.notification--box');

		if (box.classList.contains('open')) {
			box.querySelector('.action-button').innerText = '+'
			box.classList.remove('open');
			return emailContentDiv.innerHTML = ''
		}

		if (!box.classList.contains('seen')) {
			let notificationsEmailCount = localStorage.getItem('emailNotificationCount');
			box.classList.add('seen');
			if (notificationsEmailCount > 0) {
				localStorage.setItem('emailNotificationCount', parseInt((notificationsEmailCount) - 1));
				const countElement = document.querySelector('[data-toggle="notifications"] .count');
				const notificationsCount = countElement ? parseInt(countElement.textContent.trim(), 10) : 0;
				let notificationlatestCount = notificationsCount - 1;
				countElement.textContent = notificationlatestCount;
				if(notificationlatestCount == 0)
					countElement.querySelector('.count').classList.add('hide')
			}
		}


		notificationBoxes.forEach(box => {
			box.querySelector('.details--box--email').innerHTML = '';
			box.classList.remove('open')
			box.querySelector('.action-button').innerText = '+'
		});

		box.querySelector('#notificationsLoader').classList.add('showing')
		box.querySelector('.action-button').innerText = '–'

		await getEmailTemplate(campaignId, messageId, deliveryId, newsletter_id).then(({data}) => {
			if ('errors' in data) {
				box.querySelector('#notificationsLoader').classList.remove('showing')
				return emailContentDiv.innerHTML = errorHtmlTemplate()
			}

			const emailContent = data?.action?.body ?? data?.content?.body ?? '';

			const processedContent = processEmailContent(emailContent, deliveryId);

			box.classList.add('open');
			box.querySelector('#notificationsLoader').classList.remove('showing')
			emailContentDiv.innerHTML = processedContent;
		})
	}

	const setupBtnListeners = () => {
		const emailNotificationsBtn = $('.email--btn');
		const notificationsBtn = $('.notification--btn');

		notificationsBtn.on('click', async function () {
			clearNotificationList();

			getEmailNotificationList().addClass('hide');
			getNotificationList().removeClass('hide');
			notificationsBtn.addClass('active');
			emailNotificationsBtn.removeClass('active');
			offset = 0;
			hasMoreNotifications = true;
			await loadNotifications();
		})

		emailNotificationsBtn.on('click', function () {
			clearNotificationList();

			getNotificationList().addClass('hide');
			getEmailNotificationList().removeClass('hide');
			notificationsBtn.removeClass('active');
			emailNotificationsBtn.addClass('active');
			getNotificationList();
			loadEmailNotifications().then(r => {
			});
		})
	}

	const handleDeleteNotification = async (notificationId, notificationDetailId, notificationBox) => {
		try {
			const result = await updateNotification('remove', notificationId, notificationDetailId);

			if (result.error === 0) {
				notificationBox.remove();
			} else {
				logger.error('Failed to delete notification:', result.error);
			}
		} catch (error) {
			logger.error('Error deleting notification:', error);
		}
	}


	const updateNotificationCount = async () => {
		const countElement = document.querySelector('[data-toggle="notifications"] .count');
		const notificationsCount = countElement ? parseInt(countElement.textContent.trim(), 10) : 0;
		let totNotificationCount = 0;
		const lastTimestamp = localStorage.getItem('lastNotificationAPICallTimestamp');
		let notificationsEmailCount = localStorage.getItem('emailNotificationCount') ?? 0;
		const currentTime = Date.now();
		const isAPIRequired = !lastTimestamp || (currentTime - parseInt(lastTimestamp, 10) > 3600 * 1000);
		if (isAPIRequired){
			const res = await getEmailNotifications()
			notificationsEmailCount = res.unread_messages ?? 0;

			localStorage.setItem('emailNotificationCount', notificationsEmailCount);
			localStorage.setItem('lastNotificationAPICallTimestamp', currentTime);
		}

		totNotificationCount = parseInt(notificationsCount, 10) + parseInt(notificationsEmailCount, 10);
		if (countElement) {
			countElement.textContent = totNotificationCount;
			if (totNotificationCount > 0) {
				countElement.classList.remove('hide');
			}
		}
	}

	updateNotificationCount().then((r => {
	}));

	return {getNotifications, getTriggers, getModal, toggleModal, updateNotificationCount}
})();